const Message = {
  'page.404.title': 'Page not found',
  'page.404.description': 'This page is depreciated, deleted or does not exist at all.',
}

export default Message
